import { type InvoiceDto, InvoiceStatus, type UpdateInvoiceDto } from '../types'

export const buildLines = (lines: any) =>
  lines.map((line: any) => {
    return {
      description: line.description,
      quantity: Math.round(Number(line.quantity) || 0),
      unitPriceHT: Number(line.unitPriceHT).toFixed(2),
      vatRate: `/v1/taxonomies/vat_rates/${String(line.vatRateId)}`
    }
  })

export const buildCreatePayload = (
  data: any,
  issuedAtString: string,
  dueDateString: string | null,
  orderId?: number
): InvoiceDto => ({
  label: data.label,
  status: InvoiceStatus.DRAFT,
  issuedAt: issuedAtString,
  dueDate: dueDateString,
  order: `/v1/orders/${orderId}`,
  contact: data.contact ? `/v1/contacts/${data.contact}` : null,
  type: `/v1/taxonomies/invoice_types/${String(data.type)}`,
  lines: buildLines(data.lines),
  paymentMethod: data.paymentMethod as string | null,
  paidAmount:
    data.paidAmount !== undefined && data.paidAmount !== null
      ? String(Number(data.paidAmount).toFixed(2))
      : '0.00',
  paymentDate: null,
  externalRef: data.externalRef || null,
  comments: data.comments || null
})

export const buildUpdatePayload = (
  data: any,
  issuedAtString: string,
  dueDateString: string | null,
  paymentDateString: string | null,
  invoice: any
): UpdateInvoiceDto => {
  const orderIri = `/v1/orders/${invoice.order.id}`
  const contactFromForm = data.contact ? `/v1/contacts/${data.contact}` : null

  return {
    label: data.label,
    issuedAt: issuedAtString,
    dueDate: dueDateString,
    order: orderIri,
    contact: contactFromForm,
    type: `/v1/taxonomies/invoice_types/${String(data.type)}`,
    lines: buildLines(data.lines),
    paymentMethod: data.paymentMethod as string | null,
    paidAmount:
      data.paidAmount !== undefined && data.paidAmount !== null
        ? String(Number(data.paidAmount).toFixed(2))
        : '0.00',
    paymentDate: paymentDateString,
    externalRef: data.externalRef || null,
    comments: data.comments || null
  }
}
